/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import VuexPersist from 'vuex-persist';
import navigationJson from '../assets/json/navigation/bcfiremap.json';
import layerJson from '../assets/json/layers/bcfiremap.json';

Vue.use(Vuex);
const initalizeApp = true;
const onlineOnly = false;

const vuexLocalStorage = new VuexPersist({
  key: process.env.VUE_APP_SITE_ID, // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  reducer: state => ({
    // siteMeta: state.siteMeta,
    // isDrawerOpen: state.isDrawerOpen,
    navigationState: state.navigationState,
    layerState: state.layerState,
    activeNavigationSet: state.activeNavigationSet,
    mapViewState: state.mapViewState,
    version: state.version,
    aboutVisible: state.aboutVisible,
    updatesLastChecked: state.updatesLastChecked,
  }),
  // Function that passes a mutation and lets you decide if it should
  // update the state in localStorage.
  // filter: mutation => (true)
});

export default new Vuex.Store({
  state: {
    siteId: process.env.VUE_APP_SITE_ID,
    dataReady: false,
    version: process.env.VUE_APP_VERSION,
    dbTimeout: 30000,
    plumeURL: 'https://bcfiremap.com/',
    siteMeta: {
      logo: '<img src="static/rg-logo.svg"/>',
      url: process.env.VUE_APP_SITE_URL || 'AdventureConditions.com',
      name: process.env.VUE_APP_SITE_NAME || 'Adventure Conditions',
      tagline: process.env.VUE_APP_SITE_TAGLINE || 'Finding Safe and Healthy Stoke',
      hasLegends: (process.env.VUE_APP_HAS_LEGENDS === 'true'),
      hasReader: (process.env.VUE_APP_HAS_READER === 'true'),
      description: process.env.VUE_APP_DESCRIPTION || 'Adventure conditions unifies evacuation orders and alerts, road closures, air quality data, smoke conditions and weather to help navigate BC Wildfires',
      keywords: process.env.VUE_APP_KEYWORDS || 'California, fires, BC, British Columbia, Wildfires, Evacuations, Road Conditions, Smoke, Air Quality, Health',
      readerListKey: '',
    },
    activeNavigationSet: navigationJson.activeNavigationSet, // fallback active navigation set tag
    navigationState: navigationJson.navigationDefinitions, // fallback offline navigation json
    layerState: layerJson,
    mapViewState: {
      center: [
        parseFloat(process.env.VUE_APP_MAP_CENTER_LON) || -14173186.261234362,
        parseFloat(process.env.VUE_APP_MAP_CENTER_LAT) || 7196206.431941464,
      ],
      zoom: parseInt(process.env.MAP_ZOOM, 10) || 5,
    },
    aboutVisible: true,
    isDrawerOpen: false,

    // bottom sheet data
    tilesArray: [],
    isDetailsViewVisible: false,
    isReaderViewAvailable: false,
    isReaderViewVisible: false,
    coordinates: '',
    range: 50,
    updates: '',
    updatesLastChecked: 0,
    inRangeFeatures: [],
    message: {
      type: 'error',
      text: '',
    },
  },
  plugins: [vuexLocalStorage.plugin],

  getters: {
    // eslint-disable-next-line max-len
    getNavigationControlById: state => id => state.navigationState.find(control => control.id === id),
    getTiles: state => state.tiles,
    getIsDetailsViewVisible: state => state.isDetailsViewVisible,
    getIsReaderViewVisible: state => state.isReaderViewVisible,
    getLayers: state => state.layerState,
    getCoordinates: state => state.coordinates,
    getInRangeFeatures: state => state.inRangeFeatures,
  },

  mutations: {
    INITALIZE_STORE(state) {
      // get data version from site meta in DB
      // is it an update?

      if (initalizeApp) {
        console.log('navigationJson.version', navigationJson.version);
        console.log('state.version', state.version);

        axios.get('https://fire-map-updates-neiljohnston-bcfiremap.vercel.app/updates.json')
          .then((response) => {
            console.log('Update Response', response);
            state.updates = response.data.updates;
            if (state.updatesLastChecked < response.data.uts) {
              state.aboutVisible = true;
            }
          })
          .catch((e) => {
          // eslint-disable-next-line no-console
            console.log('Update Error: ', e);
            state.updates = { updates: ['<h1>Sorry there Has been a minor update error.</h1>'] };
            // failed to load so revert to existing cached layers and navigation
          });

        if (state.version === undefined
          || state.version < navigationJson.version) {
          console.log('Updating Navigation and Layer Cache');
          state.version = navigationJson.version;
          state.navigationState = navigationJson.navigationDefinitions;
          state.layerState = layerJson;
        }
        state.dataReady = true;
      } else {
        axios.get(`${state.plumeURL}getSiteMeta/${state.siteId}`, { timeout: state.dbTimeout })
          .then((response) => {
            const dbMeta = response.data;
            console.log('dbMeta:', dbMeta);

            if (onlineOnly || (dbMeta && dbMeta.version && (state.version < dbMeta.version))) {
              console.log('Updating');
              // set new map center and zoom
              state.mapViewState.center = [
                parseFloat(dbMeta.centerLon),
                parseFloat(dbMeta.centerLat),
              ];
              state.mapViewState.zoom = parseInt(dbMeta.zoom, 10);

              Promise.all([
                axios.get(`${state.plumeURL}getSiteNavigation/${state.siteId}`, { timeout: state.dbTimeout }),
                axios.get(`${state.plumeURL}getSiteLayers/${state.siteId}`, { timeout: state.dbTimeout }),
              ])
                .then(([navigationResponse, layersResponse]) => {
                  // valid responses?
                  if (
                    navigationResponse
                    && navigationResponse.data
                    && layersResponse
                    && layersResponse.data
                  ) {
                    // set new map center and zoom
                    state.mapViewState.center = [
                      parseFloat(dbMeta.centerLon),
                      parseFloat(dbMeta.centerLat),
                    ];
                    state.mapViewState.zoom = parseInt(dbMeta.zoom, 10);

                    const dbNavigation = navigationResponse.data;
                    console.log('Updating Navigation', JSON.stringify(dbNavigation));

                    state.navigationState = dbNavigation.navigationDefinitions;
                    state.activeNavigationSet = dbNavigation.activeNavigationSet;
                    console.log('dbNavigation.activeNavigationSet', dbNavigation.activeNavigationSet);

                    state.layerState = layersResponse.data;
                    console.log('Updating Layers', JSON.stringify(layersResponse.data));


                    // update local version number
                    state.version = dbMeta.version;
                  }
                })
                .catch((error) => {
                  console.log(error);
                  // fallbacks are already created in state definitions
                })
                .then(() => {
                  // update local version number
                  state.dataReady = true;
                });
            } else {
              state.dataReady = true;
            }
          })
          .catch((e) => {
            // eslint-disable-next-line no-console
            console.log(e);
            // failed to load so revert to existing cached layers and navigation
            state.dataReady = true;
          });
      }
    },

    SET_NAVIGATION_LOAD_STATE: ({ state }, { control, loadState }) => {
      control.loadState = loadState;
    },
    SET_NAVIGATION_ACTIVE: ({ state }, { control, active }) => {
      control.active = active;
    },
    SET_NAVIGATION_OPACITY: ({ state }, { control, opacity }) => {
      control.opacity = opacity;
    },
    SET_NAVIGATION_ZINDEX: ({ state }, { control, zindex }) => {
      control.zindex = zindex;
    },
    SET_IN_RANGE_FEATURES(state, features) {
      state.inRangeFeatures = features;
    },
    SET_NAVIGATION(state, navigationArray) {
      state.navigationState = navigationArray;
    },
    SET_TILES_ARRAY(state, tileArray) {
      state.tilesArray = tileArray;
    },
    PUSH_TO_TILES_ARRAY(state, tile) {
      state.tilesArray.push(tile);
    },
    SET_DETAIL_VIEW_VISIBLE(state, visible) {
      state.isDetailsViewVisible = visible;
    },
    SET_READER_VIEW_VISIBLE(state, visible) {
      state.isReaderViewVisible = visible;
    },
    SET_ABOUT_VISIBLE(state, visible) {
      state.aboutVisible = visible;
    },
    SET_DRAWER_OPEN(state, isOpen) {
      state.isDrawerOpen = isOpen;
    },
    SET_ACTIVE_NAVIGATION_SET(state, tag) {
      state.activeNavigationSet = tag;
    },
    SET_MAP_VIEW_STATE_CENTER(state, center) {
      state.mapViewState.center = center;
    },
    SET_MAP_VIEW_STATE_ZOOM(state, zoom) {
      state.mapViewState.zoom = zoom;
    },
    SET_SITE_META(state, siteMeta) {
      state.siteMeta = siteMeta;
    },
    SET_LAYERS(state, json) {
      state.layerState = json;
    },
    SET_COORDINATES(state, coordinates) {
      state.coordinates = coordinates;
    },
    SET_UPDATES_LAST_CHECKED(state) {
      const d = new Date();
      state.updatesLastChecked = Math.round(d.getTime() / 1000);
    },
    SET_MESSAGE(state, message) {
      state.message = message;
    },
  },

  actions: {
    setNavigationLoadState: ({ getters, commit }, { id, loadState }) => {
      const control = getters.getNavigationControlById(id);
      commit('SET_NAVIGATION_LOAD_STATE', { control, loadState });
    },
    setNavigationActive: ({ getters, commit }, { id, active }) => {
      const control = getters.getNavigationControlById(id);
      commit('SET_NAVIGATION_ACTIVE', { control, active });
    },
    setNavigationOpacity: ({ getters, commit }, { id, opacity }) => {
      const control = getters.getNavigationControlById(id);
      commit('SET_NAVIGATION_OPACITY', { control, opacity });
    },
    setNavigationZindex: ({ getters, commit }, { id, zindex }) => {
      const control = getters.getNavigationControlById(id);
      commit('SET_NAVIGATION_ZINDEX', { control, zindex });
    },
    setNavigation: ({ commit }, navigationArray) => {
      commit('SET_NAVIGATION', navigationArray);
    },
    setTilesArray: ({ commit }, tilesArray) => {
      commit('SET_TILES_ARRAY', tilesArray);
    },
    pushToTilesArray: ({ commit }, tile) => {
      commit('PUSH_TO_TILES_ARRAY', tile);
    },
    setDetailViewVisible: ({ commit }, visible) => {
      commit('SET_DETAIL_VIEW_VISIBLE', visible);
    },
    setReaderViewVisible: ({ commit }, visible) => {
      commit('SET_READER_VIEW_VISIBLE', visible);
    },
    setAboutVisible: ({ commit }, visible) => {
      commit('SET_ABOUT_VISIBLE', visible);
    },
    setDrawerOpen: ({ commit }, isOpen) => {
      commit('SET_DRAWER_OPEN', isOpen);
    },
    setActiveNavigationSet: ({ commit }, tag) => {
      commit('SET_ACTIVE_NAVIGATION_SET', tag);
    },
    setMapViewStateCenter: ({ commit }, center) => {
      commit('SET_MAP_VIEW_STATE_CENTER', center);
    },
    setMapViewStateZoom: ({ commit }, zoom) => {
      commit('SET_MAP_VIEW_STATE_ZOOM', zoom);
    },
    setSiteMeta: ({ commit }, siteMeta) => {
      commit('SET_SITE_META', siteMeta);
    },
    setLayers: ({ commit }, layers) => {
      commit('SET_LAYERS', layers);
    },
    setCoordinates: ({ commit }, coordinates) => {
      console.log('setCoordinates:', coordinates);
      commit('SET_COORDINATES', coordinates);
    },
    setUpdatesLastChecked: ({ commit }) => {
      console.log('setUpdatesLastChecked');
      commit('SET_UPDATES_LAST_CHECKED');
    },
    setInRangeFeatures: ({ commit }, polygons) => {
      console.log('setInRangeFeatures:', polygons);
      commit('SET_IN_RANGE_FEATURES', polygons);
    },
    setMessage: ({ commit }, message) => {
      console.log('setMessage:', message);
      commit('SET_MESSAGE', message);
    },
  },
});
